import React from 'react';
import CVForm from './components/CVForm';
import './styles/app.css';

const App = () => (
  <CVForm />
);

export default App;
